import axios from 'axios'

export default () => {
  return axios.create({
    // baseURL: 'http://localhost:3337/',
    baseURL: 'https://apiwebcheckin.fd.economysoftware.com.br/',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*'
    }
  })
}